<script setup>
   import { watchEffect, ref, inject, computed } from 'vue'

   const $storeApp = inject('$storeApp')

   const currentYear = computed(() => new Date().getFullYear())

   const version = ref('')
   watchEffect(() => version.value = $storeApp?.version)

   const stage = ref('')
   watchEffect(() => stage.value = $storeApp?.stage)
</script>

<template>
<footer class="cg-footer flex-column flex-sm-row">
  <span class="order-1 order-sm-0">Copright &copy; {{ currentYear }}. All rights reserved.</span> <span class="badge bg-warning text-dark order-0 order-sm-1">v{{ version }}{{ stage && stage != 'stable' ? '-' + stage: '' }}</span>
</footer>
</template>